<template>
<div>
  <projects-page-primary-market v-if="!InvestorRegisteredOnSecondaryMarket"/>
  <projects-page-secondary-market v-else/>
</div>
</template>

<script>

import ProjectsPagePrimaryMarket from '@views/investor/investments/ProjectsPagePrimaryMarket';
import ProjectsPageSecondaryMarket from '@views/investor/investments/ProjectsPageSecondaryMarket';
export default {
   components: { ProjectsPagePrimaryMarket, ProjectsPageSecondaryMarket },
   data(){
      return {
        
      }
   }
}
</script>